import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.scss";
import "./i18n";
import App from './app';
import pack from "../package.json";
import apiOpen from './api/open';
import { applyLayoutStylse } from './helpers/DomHelper';

applyLayoutStylse();

console.log(`AppVersion: ${pack.version}, ${pack.date}`);

const sendCashRegisterStatus = () => {
  apiOpen.sendCashRegisterStatus();
}

setInterval(() => {
  sendCashRegisterStatus();
}, 1200000);

setInterval(() => {
  localStorage.setItem("shouldUpdateApp", "true");
}, 3600000);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);